// extracted by mini-css-extract-plugin
export default {"icon":"coinIcon_icon__k1ivk","white":"coinIcon_white__9dBeH"};